import React from 'react';
export const Footer = () => {
  return <footer className="mt-16 pt-8 border-t border-gray-200 text-center" data-id="element-114">
      <div className="max-w-2xl mx-auto" data-id="element-115">
        <p className="text-xs text-gray-500 mb-4" data-id="element-116">
          This statement has not been evaluated by the Food and Drug
          Administration. This product is not intended to diagnose, treat, cure,
          or prevent any disease.
        </p>
        <div className="flex justify-center space-x-6 mb-4" data-id="element-117">
          <a href="#" className="text-gray-500 hover:text-gray-700" data-id="element-118">
            Privacy Policy
          </a>
          <a href="#" className="text-gray-500 hover:text-gray-700" data-id="element-119">
            Terms of Service
          </a>
          <a href="#" className="text-gray-500 hover:text-gray-700" data-id="element-120">
            Contact Us
          </a>
        </div>
        <p className="text-xs text-gray-500" data-id="element-121">
          © 2023 Clarity. All rights reserved.
        </p>
      </div>
    </footer>;
};